import { useContext } from 'react'

import { AuthContext } from '@/app/provider/auth-provider'

/**
 * Returns the context of the AuthProvider (Better-Auth).
 * The context includes the current user and methods to sign in, sign out and check if the user is authenticated.
 * This hook should be used within an AuthProvider.
 */
export function useAuth() {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
